export const END_NUMBER = 0.99;
export const START_NUMBER = 0;
